import { RATES } from '../data/fleet'

export default function Rates() {
  return (
    <section className="section" id="rates">
      <div className="wrap">
        <div className="section__head">
          <span className="eyebrow">Rates</span>
          <h2>Published, so you can bid the job</h2>
          <p>{RATES.note}</p>
        </div>

        <div className="split">
          <table className="rates">
            <caption>Rental</caption>
            <thead>
              <tr>
                <th scope="col">Unit</th>
                <th scope="col">1 day</th>
                <th scope="col">3 days</th>
                <th scope="col">Week</th>
              </tr>
            </thead>
            <tbody>
              {RATES.rows.map((row) => (
                <tr key={row.label}>
                  <th scope="row">{row.label}</th>
                  <td>{row.day}</td>
                  <td>{row.threeDay}</td>
                  <td>{row.week}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div>
            <table className="rates">
              <caption>Delivery &mdash; optional</caption>
              <tbody>
                {RATES.delivery.map((row) => (
                  <tr key={row.label}>
                    <th scope="row">{row.label}</th>
                    <td>{row.fee}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <p className="rates__note">
              Pick up at our lot at no charge, any hour. Delivery is measured
              from the lot and collected with the rental.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
